import { useEffect, useState } from "react";
import { api } from "./api";

/* Canonical email records (Communication Centre store) linked to the given deals. */
export function useDealEmails(dealIds, enabled = true) {
  const [emails, setEmails] = useState([]);
  const key = (dealIds || []).filter(Boolean).join(",");
  useEffect(() => {
    if (!enabled || !key) { setEmails([]); return undefined; }
    let alive = true;
    Promise.all(key.split(",").map((id) =>
      api.get(`/api/v2/mailbox/for-deal/${id}`).then(({ data }) => (Array.isArray(data) ? data : [])).catch(() => [])))
      .then((lists) => { if (alive) setEmails(lists.flat()); });
    return () => { alive = false; };
  }, [key, enabled]);
  return emails;
}
